import Image from 'next/image';
import classnames from 'classnames';

import CheckIcon from 'static/icons/check.svg';
import CloseIcon from 'static/icons/filled_close.svg';
import classes from './Notification.module.css';

type Props = {
   text: string;
   isSuccess?: boolean;
   className?: string;
};

const Notification = ({ text, isSuccess = true, className }: Props) => (
   <div className={classnames(classes.notification, { [classes.failed]: !isSuccess }, className)}>
      <div className={classes.icon}>
         <Image src={isSuccess ? CheckIcon : CloseIcon} alt="" />
      </div>

      <p className={classes.text}>{text}</p>
   </div>
);

export default Notification;
